const baseUrl = 'http://thermofisher-cad-from-three.ms-vm.synconize.com/prod-api/' // 线上
// const baseUrl = 'http://101.132.254.160:7130/' // 线下

export default baseUrl
